import { forwardRef, useEffect } from 'react'
import styled from '@emotion/styled'
import SignaturePad from 'react-signature-pad-wrapper'
import { FusionColor } from '../../../theme/FusionStyle'
import { useTheme } from '@emotion/react'

const SignatureContainer = styled.div(({theme}) => ({
	position: 'relative',
	borderBottomLeftRadius: 15,
	borderBottomRightRadius: 15,
	padding: theme.spacing(4, 0),
	width: '100%',
}))

const SignatureLine = styled.div(({theme}) => ({
	position: 'absolute',
	left: theme.spacing(5),
	right: theme.spacing(5),
	bottom: theme.spacing(8),
	borderBottom: '1px dotted #707070',
}))

interface L1SignaturePadProps {
	onBeginStroke?: () => void
}

const L1SignaturePad = forwardRef<SignaturePad, L1SignaturePadProps>(({onBeginStroke}, sigRef) => {
	const theme = useTheme()
	const numericHeight = parseInt(theme.spacing(20), 10)
	useEffect(() => {
		if (!sigRef || typeof sigRef === 'function') return
		const currentCanvas = sigRef.current?.canvas.current
		if(currentCanvas) {
			sigRef.current?.scaleCanvas(currentCanvas)
			currentCanvas.style.borderRadius = '10px'
		}
		const instance = sigRef.current?.instance
		if(instance && onBeginStroke) {
			instance.addEventListener('beginStroke', onBeginStroke)
			return () => {
				instance.removeEventListener('beginStroke', onBeginStroke)
			}
		}
	})
	return (
		<SignatureContainer>
			<SignaturePad
				ref={sigRef}
				height={numericHeight}
				options={{backgroundColor: theme.colors[FusionColor.White]}}
				redrawOnResize />
			<SignatureLine />
		</SignatureContainer>
	)
})

export default L1SignaturePad